'use client';

import { c as _c } from "react/compiler-runtime";
import { domAnimation, LazyMotion, m, useReducedMotion } from 'motion/react';
import type { ReactNode } from 'react';
import { MotionAnimatedAutoHeight } from '@/components/ui/motion-animated-auto-height';
import { MOTION_POSITION_SMALL } from '@/lib/ui/easing';
interface MarketDetailTabTransitionProps {
  children: ReactNode;
  activeTab: string;
  animateChanges: boolean;
}
export function MarketDetailTabTransition(t0) {
  const $ = _c(14);
  const {
    children,
    activeTab,
    animateChanges
  } = t0;
  const reducedMotion = useReducedMotion();
  let t1;
  if ($[0] !== animateChanges || $[1] !== reducedMotion) {
    t1 = animateChanges && !reducedMotion ? {
      opacity: 0
    } : false;
    $[0] = animateChanges;
    $[1] = reducedMotion;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 1
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== reducedMotion) {
    t3 = reducedMotion ? {
      duration: 0
    } : MOTION_POSITION_SMALL;
    $[4] = reducedMotion;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== activeTab || $[7] !== children || $[8] !== t1 || $[9] !== t3) {
    t4 = <LazyMotion features={domAnimation}><m.div key={activeTab} className="flex w-full min-w-0 flex-col" initial={t1} animate={t2} transition={t3}>{children}</m.div></LazyMotion>;
    $[6] = activeTab;
    $[7] = children;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== animateChanges || $[12] !== t4) {
    t5 = <MotionAnimatedAutoHeight animateChanges={animateChanges} className="min-w-0">{t4}</MotionAnimatedAutoHeight>;
    $[11] = animateChanges;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}